import { numberToLong2pakxeg38estk as numberToLong } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function getCurrentTime() {
  return numberToLong(Date.now());
}
//region block: exports
export {
  getCurrentTime as getCurrentTime16j9973nx5x63,
};
//endregion

//# sourceMappingURL=KLoggingClock.mjs.map
